import React from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";


const StartpageButton = () => {
  const history = useHistory();
  return (
    <div className="text-center my-4">
      <button
        className="btn btn-outline-dark"
        onClick={() => history.push("/login")}
      >
        Direkt zur Anmeldung (Login)
      </button>

    </div>
  );
};
export default StartpageButton;
